import type { HTMLAttributes } from 'react';
import { tv, type VariantProps } from 'tailwind-variants';

export const cardStyles = tv({
  base: 'rounded-lg bg-surface text-fg',
  variants: {
    elevation: {
      flat: 'border border-border',
      raised: 'bg-raised shadow-md',
    },
    padding: { none: '', sm: 'p-3', md: 'p-4 sm:p-6' },
  },
  defaultVariants: { elevation: 'flat', padding: 'md' },
});

export interface CardProps extends HTMLAttributes<HTMLDivElement>, VariantProps<typeof cardStyles> {}

export function Card({ elevation, padding, className, ...props }: CardProps) {
  return <div {...props} className={cardStyles({ elevation, padding, className })} />;
}
